module.exports = __webpack_public_path__ + "static/media/risks.5b1975d8.svg";